angular.module 'zc.core'
.factory 'InterestWidget', ($q, $translate, Api, Campaign) ->
  class InterestWidget
    DUMMY_ID = -1
    AB_DELIVERY = { id: 'ab_delivery', name: $translate.instant('sharedModules.core.services.interestWidget.abDelivery') }
    COMPLETE_DELIVERY = { id: 'complete_delivery', name: $translate.instant('sharedModules.core.services.interestWidget.completeDelivery') }

    @all: (apikey) ->
      $q.reject null if !apikey
      Api.get "/api/projects/apikey:#{apikey}/interest_widgets", {}, cache: false
      .then (res) ->
        unless res.data.success
          $q.reject res
          return
        res.data.interest_widgets

    @get: (apikey, id) ->
      $q.reject null if !apikey
      Api.get "/api/projects/apikey:#{apikey}/interest_widgets/#{id}", {}, cache: false
      .then (res) ->
        unless res.data.success
          $q.reject res
          return
        res.data.interest_widget

    @create: (apikey, interest_widget) ->
      $q.reject null if !apikey
      Api.post "/api/projects/apikey:#{apikey}/interest_widgets/", {interest_widget}, cache: false
      .then (res) ->
        unless res.data.success
          $q.reject res
          return
        res.data.interest_widget

    @update: (apikey, id, interest_widget) ->
      $q.reject null if !apikey
      Api.patch "/api/projects/apikey:#{apikey}/interest_widgets/#{id}", {interest_widget}, cache: false
      .then (res) ->
        unless res.data.success
          $q.reject res
          return
        res.data.interest_widget

    @remove: (apikey, id, interest_widget) ->
      $q.reject null if !apikey
      Api.delete "/api/projects/apikey:#{apikey}/interest_widgets/#{id}", cache: false
      .then (res) ->
        unless res.data.success
          $q.reject res
          return
        res.data.interest_widget

    @updateCampaignWithInterestWidget = (campaign) ->
      Campaign.isWidget(campaign)
      .then (isWidget) ->
        campaign.is_coupon_campaign = !isWidget
        if campaign.is_coupon_campaign
          campaign.available_delivery_type_options = [AB_DELIVERY]
        else
          campaign.available_delivery_type_options = [AB_DELIVERY, COMPLETE_DELIVERY]
          campaign.days_since_last_received = 0

        # User selected complete_delivery and has not saved yet.
        if campaign.delivery_type_option?.id == 'complete_delivery'
          if !campaign.interest_widget_id
            campaign.interest_widget_id = DUMMY_ID
        # User selected ab_delivery and has not saved yet.
        else if campaign.delivery_type_option?.id == 'ab_delivery'
          if campaign.interest_widget_id
            campaign.interest_widget_id = 0

        if campaign.interest_widget_id && !campaign.is_coupon_campaign
          campaign.delivery_type_option = COMPLETE_DELIVERY
        else
          campaign.delivery_type_option = AB_DELIVERY
          campaign.interest_widget_id = 0



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/interest_widget.service.coffee